/* eslint-disable no-underscore-dangle */
import { Injector, Type } from '@angular/core';
import { Route, Routes } from '@angular/router';
import { LogicService } from '../../service/logic/logic.service';
import { FilterFlowRouteArgs, WorkflowRouteGuard, WorkflowService } from '../../service/workflow/workflow.service';
export interface ModuleInitializer {
  RegisterLogicServices(injector: Injector): void;
  RegisterRoutes(injector: Injector, routeFilter: FilterFlowRouteArgs): void;
}

interface RouteConfig {
  /** Route component */
  componentClass: Route['component'];

  /** Route guard config that will be used when the route is registered */
  guards?: WorkflowRouteGuard;

  /** Product type */
  products: string[];

  routePrefix: string;
}

// tslint:disable-next-line: completed-docs
export class ModuleInitializerHelper implements ModuleInitializer {
  /** logic services repository */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly _logicServices: Type<any>[] = [];

  /** route configs */
  private readonly _routeConfigs: RouteConfig[] = [];

  public RegisterLogicServices(injector: Injector): void {
    for (const logicServiceType of this._logicServices) {
      injector.get(LogicService).register(injector.get(logicServiceType));
    }
  }

  public RegisterRoutes(injector: Injector, routeFilter?: FilterFlowRouteArgs): void {
    for (const route of this._routeConfigs) {
      injector
        .get(WorkflowService)
        .addRoutesWithPrefix(route.routePrefix, route.componentClass, route.guards, routeFilter, ...route.products);
    }
  }

  public GetNgRoutes(injector: Injector, routeFilter?: FilterFlowRouteArgs): Routes {
    const result = [];
    for (const route of this._routeConfigs) {
      const routes = injector
        .get(WorkflowService)
        .buildNgRoutes(route.routePrefix, route.componentClass, route.guards, routeFilter, ...route.products);
      result.push(...routes);
    }

    return result;
  }

  public AddLogicService<T>(logicService: Type<T>): ModuleInitializerHelper {
    this._logicServices.push(logicService);
    return this;
  }

  public AddValidationService<T>(logicService: Type<T>): ModuleInitializerHelper {
    return this.AddLogicService(logicService);
  }

  public AddRoute(
    routePrefix: string,
    componentClass: Route['component'],
    guards?: WorkflowRouteGuard,
    ...products: string[]
  ): ModuleInitializerHelper {
    this._routeConfigs.push({ componentClass, guards, products, routePrefix });
    return this;
  }
}
